import React, {useState, useReducer} from 'react';
//import { googleFormsToJson } from 'react-google-forms-hooks';


const formReducer = (state, event) => {
    return{
        ...state,
        [event.name]: event.value
    }
}

export const ContactForm = () => {
    const [formData, setFormData] = useReducer(formReducer, {}); 
    //const [firstName, lastName, email, shortAnser ] = useState(); 
    const [submitting, setSubmitting] = useState(false);
    const googleFormId = '1FAIpQLSd_P4YE2xPFUrXjJ0eLZ90pnXf0DURMOsxm5s9rI6neT7YITA';
    const appScriptUrl = 'https://script.google.com/macros/s/AKfycbz-MxaYWw0uGraNBpidyNwb-cIDDyJK_WK0UE_OAsOl-tZRvs496TW0c9R2JnUYuOQv-g/exec'

    const handleSubmit = event => {
        event.preventDefault(); 
        console.log(formData);
        setSubmitting(true);

        //old form url
        const formUrl = "https://docs.google.com/forms/u/0/d/e/" + googleFormId + "/formResponse?";
        const queryURLData = new URLSearchParams(formData).toString(); 
        const formPostUrl = formUrl + queryURLData; 

        const requestOptions = {
            method: "POST",
            mode: "no-cors",
            headers: {"content-Type": "application/json"},
            body: JSON.stringify(formData)
        }

        console.log(formPostUrl);

        fetch(appScriptUrl, requestOptions)
            .then(response => {
                if(response.status === 200){
                    console.log('SUCCESS!!!!');
                } else { 
                    console.log('Failed');
                    console.log(response.status);
                    
                }
            }).then((data) => {
                setSubmitting(false); 
            }); 
    };

    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        });
    }

    return(
        <div className="contact-form-container">
            {submitting && 
                <div>
                    You are submitting the following data: 
                    <ul>
                        {Object.entries(formData).map(([name, value]) => (
                            <li key={name}><strong>{name}</strong>:{value.toString()}</li>
                        ))}
                    </ul>
                </div>
            }
            <form onSubmit={handleSubmit}>
                <input 
                    class="input" 
                    type="text"
                    name="firstname"
                    placeholder="First Name"
                    onChange={handleChange}
                />
                <input 
                    class="input" 
                    type="text"
                    name="lastname" 
                    placeholder="Last Name" 
                    onChange={handleChange}
                />
                <input 
                    class="input"
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={handleChange}
                />
                <textarea 
                    class="input"
                    type="textarea"
                    name="howcanihelp"
                    placeholder="How Can I help?"
                    onChange={handleChange}
                />
                <button className="button" type="submit" >
                    Submit
                </button>
            </form>
        </div>
    )
}